var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconReorder = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Layer 1",
  viewBox: "0 0 24 24"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 14.61,
  cy: 5.46,
  r: 1.87
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.61,
  cy: 11.98,
  r: 1.87
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.61,
  cy: 18.5,
  r: 1.87
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.03,
  cy: 5.46,
  r: 1.87
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.03,
  cy: 11.98,
  r: 1.87
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.03,
  cy: 18.5,
  r: 1.87
})));

export default SvgIconReorder;